import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";
import { ChildrenDto } from "../types";
import { SidebarProvider } from "./SidebarProvider";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../config/connection/react-query';
import Notifications from "../components/Notifications/Notifications";
import { ReportProvider } from "./ReportContext";
import { TEMA_DO_SITE } from "../config/tema";

export const AppProvider = ({ children }: ChildrenDto) => {
    return (
        <QueryClientProvider client={queryClient}>
            {/* Sem o locale, os textos embutidos do antd (tabela vazia, dicas de ordenacao, Select sem
              * opcoes, botoes de modal) aparecem em ingles. O tema leva as cores do site
              * (roxo da marca em vez do azul padrao) para todos os componentes do antd. */}
            <ConfigProvider locale={ptBR} theme={TEMA_DO_SITE}>
                <Notifications />
                <BrowserRouter>
                    <ReportProvider>
                        <SidebarProvider>
                            {children}
                        </SidebarProvider>
                    </ReportProvider>
                </BrowserRouter>
            </ConfigProvider>
        </QueryClientProvider>
    );
};